import QueryString from 'query-string';

import CookieService from './CookieService';

class SearchService {
    static search = async (query, offset = 0, amount = 20) => {
        const langcode = CookieService.get('DNSBELGIUM_LANGUAGE');
        const parameters = QueryString.stringify({
            q: `${langcode}:${query}`,
            o: offset,
            a: amount,
        });

        const response = await fetch(`/search/json?${parameters}`, {
            method: 'GET',
            credentials: 'same-origin',
        });

        return response.json();
    };
}

export default SearchService;
